import constants from "../../helpers/constants";

export default function Option(props) {
    return (<>
        {(props.dataType == "text" || props.dataType=="dropdown") && <>
            <option>{constants.CONTAINS}</option>
            <option>Not Contains</option>
            <option>Equals</option>
            <option>Not Equals</option>
            <option>Starts With</option>
            <option>Ends With</option>
            <option>Blank</option>
            <option>Not Blank</option>
        </>}
        { (props.dataType == "number" || props.dataType == "date") && <>
            <option>Equals</option>
            <option>Not Equals</option>
            <option>Greater Than</option>
            <option>Greater Than or Equal</option>
            <option>Less Than</option>
            <option>Less Than or Equal</option>
            <option>Range</option>
            <option>Blank</option>
            <option>Not Blank</option>
        </>}
    </>
    )
}

export function Options (dataType) {
    let options = [];

    if (dataType == "text" || dataType=="dropdown") {
        options = [
            "Contains",
            "Not Contains",
            "Equals",
            "Not Equals",
            "Starts With",
            "Ends With",
            "Blank",
            "Not Blank",
        ]
    }
    else if (dataType == "number" || dataType == "date") {
        options = [
            "Equals",
            "Not Equals",
            "Greater Than",
            "Greater Than or Equal",
            "Less Than",
            "Less Than or Equal",
            "Range",
            "Blank",
            "Not Blank",
        ]
    }
    return options
}